import { render, staticRenderFns } from "./Accept.vue?vue&type=template&id=6560b31c"
import script from "./Accept.vue?vue&type=script&lang=js"
export * from "./Accept.vue?vue&type=script&lang=js"
import style0 from "./Accept.vue?vue&type=style&index=0&id=6560b31c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports